"use strict";

var _objectSpread = require("D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");
var _slicedToArray = require("D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMouseEventOptions = getMouseEventOptions;
function isMousePressEvent(event) {
  return event === 'mousedown' || event === 'mouseup' || event === 'click' || event === 'dblclick';
} // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons

var BUTTONS_NAMES = {
  none: 0,
  primary: 1,
  secondary: 2,
  auxiliary: 4
}; // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button

var BUTTON_NAMES = {
  primary: 0,
  auxiliary: 1,
  secondary: 2
};
function translateButtonNumber(value, from) {
  var _Object$entries$find;
  var _ref = from === 'button' ? [BUTTON_NAMES, BUTTONS_NAMES] : [BUTTONS_NAMES, BUTTON_NAMES],
    _ref2 = _slicedToArray(_ref, 2),
    mapIn = _ref2[0],
    mapOut = _ref2[1];
  var name = (_Object$entries$find = Object.entries(mapIn).find(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      i = _ref4[1];
    return i === value;
  })) == null ? void 0 : _Object$entries$find[0]; // istanbul ignore next

  return name && Object.prototype.hasOwnProperty.call(mapOut, name) ? mapOut[name] : 0;
}
function convertMouseButtons(event, init, property) {
  if (!isMousePressEvent(event)) {
    return 0;
  }
  if (typeof init[property] === 'number') {
    return init[property];
  } else if (property === 'button' && typeof init.buttons === 'number') {
    return translateButtonNumber(init.buttons, 'buttons');
  } else if (property === 'buttons' && typeof init.button === 'number') {
    return translateButtonNumber(init.button, 'button');
  }
  return property != 'button' && isMousePressEvent(event) ? 1 : 0;
}
function getMouseEventOptions(event, init) {
  var clickCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var _init;
  init = (_init = init) != null ? _init : {};
  return _objectSpread({}, init, {
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    detail: event === 'mousedown' || event === 'mouseup' || event === 'click' ? 1 + clickCount : clickCount,
    buttons: convertMouseButtons(event, init, 'buttons'),
    button: convertMouseButtons(event, init, 'button')
  });
}